/**
 * Guard check if user have access rights to block (menu item).
 *
 * @author Artem Bakulin <dekkyartem@gmail.com>
 */

import { NavigationGuard, Route } from 'vue-router';

import userModule from '@/store/user';

const guard: NavigationGuard = (to: Route, _, next): void => {
    if (to.name && to.meta.roles && userModule.role) {
        if (to.meta.roles.includes(userModule.role)) {
            return next();
        }
        
        return next({ name: 'home' });
    }
    
    next();
};

export default guard;
